import { notifications } from '@mantine/notifications';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Project } from '@/types/types';

const useDeleteProject = () => {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (projectId: Project['id']) => {
      await axiosInstance.delete(`/api/v1/projects/${projectId}`);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects._def });
      notifications.show({
        title: 'Succes',
        message: 'Projekt blev slettet',
        color: 'green',
      });
    },
    onError: () => {
      notifications.show({
        title: 'Fejl',
        message: 'Kunne ikke slette projekt',
        color: 'red',
      });
    },
  });
};

export default useDeleteProject;
